import { Grid, html } from "gridjs";
import "gridjs/dist/theme/mermaid.css";
import { uiState } from "../../state/uiState.js";

let uyeliklerGrid = null;
let didBindGridEvents = false;

function escapeHtml(value) {
	return String(value ?? "")
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;");
}

function ellipsisCell(cell, className = "") {
	const text = cell === null || cell === undefined || cell === "" ? "—" : String(cell);
	const safe = escapeHtml(text);
	const cls = ["grid-cell-ellipsis", className].filter(Boolean).join(" ");
	return html(`<span class="${cls}" title="${safe}">${safe}</span>`);
}

export function initUyeliklerGridEvents() {
	if (didBindGridEvents) return;
	didBindGridEvents = true;

	document.body.addEventListener("change", (e) => {
		if (e.target?.matches(".uyelikler-per-page")) {
			const value = Number(e.target.value);
			uiState.uyelikler.paginationLimit = value;
			rerenderUyeliklerGridWithLastUrl(value);
		}
	});

	document.body.addEventListener("click", (e) => {
		const viewBtn = e.target.closest(".uyelikler-grid-action-btn--view");
		const editBtn = e.target.closest(".uyelikler-grid-action-btn--edit");
		const toggleBtn = e.target.closest(".uyelikler-grid-action-btn--toggle");
		const sifreBtn = e.target.closest(".uyelikler-grid-action-btn--sifre");
		const deleteBtn = e.target.closest(".uyelikler-grid-action-btn--delete");
		if (viewBtn) window.openUyeliklerOverviewDialog?.(viewBtn.dataset.id);
		if (editBtn) window.openUyeliklerEditDialog?.(editBtn.dataset.id);
		if (toggleBtn) {
			window.openUyeliklerDurumDialog?.(
				toggleBtn.dataset.id,
				toggleBtn.dataset.label,
				toggleBtn.dataset.active === "1",
			);
		}
		if (sifreBtn) {
			window.openUyeliklerSifreDialog?.(
				sifreBtn.dataset.id,
				sifreBtn.dataset.ad,
				sifreBtn.dataset.soyad,
				sifreBtn.dataset.tc,
				sifreBtn.dataset.email,
			);
		}
		if (deleteBtn) {
			window.openUyeliklerDeleteDialog?.(
				deleteBtn.dataset.id,
				deleteBtn.dataset.label,
			);
		}
	});
}

export function renderUyeliklerGrid({ url, paginationLimit = 10 }) {
	uiState.uyelikler.lastSearchUrl = url;
	uiState.uyelikler.paginationLimit = paginationLimit;

	if (uyeliklerGrid) {
		uyeliklerGrid.destroy();
		uyeliklerGrid = null;
	}

	const tableGrid = document.querySelector(".uyelikler-table-grid");
	if (!tableGrid) return;
	tableGrid.innerHTML = "";

	const col = (id, name, minWidth, className = "") => ({
		id,
		name: html(`<div style="margin-top:3px;">${name}</div>`),
		minWidth,
		formatter: (cell) => ellipsisCell(cell, className),
	});

	uyeliklerGrid = new Grid({
		columns: [
			col("first_name", "Ad", "120px"),
			col("last_name", "Soyad", "120px"),
			col("kisi_tc", "T.C.", "140px"),
			col("email", "Email", "200px", "grid-cell-ellipsis--xxwide"),
			col("yetki_adi", "Yetki", "110px"),
			col("olusturma_tarihi", "Kayit Tarihi", "140px"),
			{
				id: "is_active",
				name: html('<div style="margin-top:3px;">Uyelik Durumu</div>'),
				sort: false,
				formatter: (cell) => {
					const aktif = cell === 1 || cell === true;
					return html(
						aktif
							? `<span class="kisiler-durum-badge kisiler-durum-badge--aktif">Aktif</span>`
							: `<span class="kisiler-durum-badge kisiler-durum-badge--pasif">Pasif</span>`,
					);
				},
			},
			{
				id: "aksiyon",
				name: html('<div style="cursor:default; text-align:center;">Islemler</div>'),
				sort: false,
				formatter: (cell, row) => {
					const firstName = row?.cells?.[0]?.data ?? "";
					const lastName = row?.cells?.[1]?.data ?? "";
					const tc = row?.cells?.[2]?.data ?? "";
					const email = row?.cells?.[3]?.data ?? "";
					const isActive = row?.cells?.[6]?.data;
					const label = `${firstName} ${lastName}`.trim();
					const id = cell ?? "";
					const isSelf = String(id) === String(uiState.currentUser?.id);
					const toggleIcon = isActive ? "person_off" : "person_add";
					const toggleTitle = isActive ? "Pasife Al" : "Aktife Al";
					return html(`
						<div class="grid-actions">
							<button class="grid-action-btn uyelikler-grid-action-btn--view" data-id="${id}" title="Goruntule">
								<span class="material-icons">visibility</span>
							</button>
							${isSelf ? `<span class="grid-self-badge" title="Bu sizsiniz"><span class="material-icons">person</span></span>` : `
							<button class="grid-action-btn uyelikler-grid-action-btn--edit" data-id="${id}" title="Duzenle">
								<span class="material-icons">edit</span>
							</button>
							<button class="grid-action-btn uyelikler-grid-action-btn--toggle" data-id="${id}" data-label="${label}" data-active="${isActive ? "1" : "0"}" title="${toggleTitle}">
								<span class="material-icons">${toggleIcon}</span>
							</button>
							<button class="grid-action-btn uyelikler-grid-action-btn--sifre" data-id="${id}" data-ad="${firstName}" data-soyad="${lastName}" data-tc="${tc}" data-email="${email}" title="Yeni Sifre Olustur">
								<span class="material-icons">lock_reset</span>
							</button>
							<button class="grid-action-btn uyelikler-grid-action-btn--delete" data-id="${id}" data-label="${label}" title="Uyeligi Sil">
								<span class="material-icons">delete</span>
							</button>`}
						</div>
					`);
				},
				attributes: {
					style: "position: sticky; right: 0; padding: 8px 12px; min-width: 210px;",
				},
			},
		],

		server: {
			url,
			then: (data) => {
				const total = data.count ?? 0;
				const countEl = document.getElementById("uyelikler-count");
				if (countEl) countEl.textContent = `${total} kayit`;
				return (data.items || []).map((row) => [
					row.first_name,
					row.last_name,
					row.kisi_tc,
					row.email,
					row.yetki_adi,
					row.olusturma_tarihi
						? new Date(row.olusturma_tarihi).toLocaleDateString("tr-TR")
						: "—",
					row.is_active,
					row.id,
				]);
			},
			total: (data) => data.count ?? 0,
		},

		autoWidth: false,
		search: false,
		sort: true,
		pagination: { limit: paginationLimit },
		fixedHeader: false,

		style: {
			container: { padding: "0px" },
			footer: { "border-radius": "0px", "box-shadow": "none" },
			header: { padding: "10px 20px" },
			table: { "white-space": "nowrap", "font-size": "11px", "margin-bottom": "3px" },
			th: { padding: "8px 16px" },
			td: { padding: "10px 16px" },
		},
	}).render(tableGrid);

	initUyeliklerGridFooter();
}

export function rerenderUyeliklerGridWithLastUrl(paginationLimit) {
	const lastUrl = uiState.uyelikler.lastSearchUrl;
	if (!lastUrl) return;
	renderUyeliklerGrid({ url: lastUrl, paginationLimit });
}

export function clearUyeliklerGrid() {
	if (uyeliklerGrid) {
		uyeliklerGrid.destroy();
		uyeliklerGrid = null;
	}
	const tableGrid = document.querySelector(".uyelikler-table-grid");
	if (tableGrid) tableGrid.innerHTML = "";
	uiState.uyelikler.lastSearchUrl = null;
	uiState.uyelikler.paginationLimit = 10;
}

function initUyeliklerGridFooter() {
	requestAnimationFrame(() => {
		const pagination = document.querySelector(".uyelikler-table-grid .gridjs-pagination");
		if (!pagination) return;
		if (pagination.querySelector(".uyelikler-per-page-container")) return;

		const perPageContainer = document.createElement("div");
		perPageContainer.classList.add("per-page-container", "uyelikler-per-page-container");

		const label = document.createElement("span");
		label.textContent = "Sayfa basi:";

		const select = document.createElement("select");
		select.classList.add("uyelikler-per-page");

		["5", "10", "25", "50", "100"].forEach((val) => {
			const opt = document.createElement("option");
			opt.value = val;
			opt.textContent = val;
			if (val === String(uiState.uyelikler.paginationLimit)) opt.selected = true;
			select.appendChild(opt);
		});

		perPageContainer.appendChild(label);
		perPageContainer.appendChild(select);
		pagination.appendChild(perPageContainer);
	});
}
